import { endOfDay, startOfDay } from 'date-fns';
import { z } from 'zod';

import { parseDate } from '~/utils/datetime';

import {
  REPROCESSING_INVOICE_CHANNEL,
  REPROCESSING_INVOICE_STATUS,
} from '../useQueryReprocessingInvoices';

import { TIME_AGGREGATION } from './constants';

export const zodReprocessingInvoicesCountsPayloadSchema = z
  .object({
    aggregateBy: z.enum(TIME_AGGREGATION).prefault('day'),
    channel: z
      .union([
        z.enum(REPROCESSING_INVOICE_CHANNEL).transform((value) => [value]),
        z.array(z.enum(REPROCESSING_INVOICE_CHANNEL)),
      ])
      .refine((channels) => channels.length === new Set(channels).size, {
        error: 'Channel values must be unique',
      })
      .prefault([]),
    createdAfter: z
      .union([z.iso.datetime(), z.string()])
      .nullish()
      .transform((value) =>
        value ? (startOfDay(parseDate(value))?.toISOString() ?? null) : null,
      ),
    createdBefore: z
      .union([z.iso.datetime(), z.string()])
      .nullish()
      .transform((value) =>
        value ? (endOfDay(parseDate(value))?.toISOString() ?? null) : null,
      ),
    dryRun: z
      .union([
        z.boolean(),
        z
          .string()
          .refine((value) => value === 'true' || value === 'false', {
            error: "String must be 'true' or 'false'",
          })
          .transform((value) => value === 'true'),
      ])
      .optional(),
    needsAiParsing: z
      .union([
        z.boolean(),
        z
          .string()
          .refine((value) => value === 'true' || value === 'false', {
            error: "String must be 'true' or 'false'",
          })
          .transform((value) => value === 'true'),
      ])
      .optional(),
    searchString: z.string().prefault(''),
    status: z
      .union([
        z.enum(REPROCESSING_INVOICE_STATUS).transform((value) => [value]),
        z.array(z.enum(REPROCESSING_INVOICE_STATUS)),
      ])
      .refine((statuses) => statuses.length === new Set(statuses).size, {
        error: 'Status values must be unique',
      })
      .prefault([]),
  })
  .transform((value) =>
    Object.fromEntries(
      Object.entries(value).filter(
        ([_, value]) => !(Array.isArray(value) && value.length === 0),
      ),
    ),
  );
